import { IAuthContextState, IAuthContextUser } from "./auth.types";

export const defaultAuthContextUser: IAuthContextUser = {
  token: "",
  isOTPPreview: false,
  name: "",
  security: [],
  user: {
    email: "",
    first_name: "",
    last_name: "",
    mobile_no: "",
    role_id: -1,
    status: "ACTIVE",
    user_uuid: "",
    role_name: "",
    role_value: "",
    role_group: "",
    full_name: "",
    affiliated_billing_company_uuids: [],
  },
};

export const defaultAuthContextState: IAuthContextState = {
  userInfo: defaultAuthContextUser,
  isLogin: false,
  login: () => {},
  verifyOTP: () => {},
  logout: () => {},
  addUserName: () => {},
};
